<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:14:49
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-06-01 07:46:42
 * @Description: 统计数据卡片模块--本周
 -->
<template>
  <div class="observe-data">
    <div class="observe-data__card-container-1">
      <num-card :total="cloudView" danwei="景" name="本周上云" color="#F74C32" bgcolor="#FDF2F1"/>
      <num-card :total="cloudSize" danwei="T" name="本周上云" color="#7A73FF" bgcolor="#F1F0FD" />
      <num-card :total="pushView" danwei="景" name="本周推送" color="#29B7A3" bgcolor="#F7FFFE"/>
    </div>
    <div class="observe-data__card-container-2">
      <num-card :total="lweekCloudView" danwei="景" name="上周上云" color="#45AAFB" bgcolor="#F7FDFF"/>
      <num-card :total="lweekCloudSize" danwei="T" name="上周上云" color="#F78704" bgcolor="#FFF9F2"/>
      <num-card :total="lweekPushView" danwei="景" name="上周推送" color="#EB4DDB" bgcolor="#FCF7FF"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NumCard from '@/components/num-card'

import {
  GET_STATISTICS,
} from '@/assets/const-value/interface'

moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
export default {
  components: {
    NumCard,
  },
  data() {
    return {
      cloudView: 0,
      cloudSize: 0,
      pushView: 0,
      lweekCloudView: 0,
      lweekCloudSize: 0,
      lweekPushView: 0,
    }
  },
  created() {
    this.getStatistics()
  },
  methods: {
    /**
     * 获取覆盖率数据
     */
    async getStatistics() {
      const year = moment().year()
      const periodWeek = 4 // week
      // const periodWeek8 = 8
      // const periodWeek = 4
      const period = moment().format('YYYYww')
      const periodLast = moment().add(-1, 'week').format('YYYYww')
      const satelliteGroupId19 = 19 // 可见光（8个卫星的组）
      const typeUpload = 1 // cloud
      const typePush = 3 // push
      const regionIdOrPushuser = '-' // 全球

      // 本周上云
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodWeek, period, satelliteGroupId: satelliteGroupId19, type: typeUpload, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0 && res.data) {
          const cloudViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          const cloudSizeAdd = res.data.children.length ? res.data.children[0].sizeCurrent : 0
          this.cloudView = cloudViewAdd
          this.cloudSize = (cloudSizeAdd / 1024 / 1024 / 1024 / 1024).toFixed(2)
        }
      }).catch(err => console.error(err))

      // 上周上云
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodWeek, period: periodLast, satelliteGroupId: satelliteGroupId19, type: typeUpload, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0 && res.data) {
        // if (res.code === 0) {
          const cloudViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          const cloudSizeAdd = res.data.children.length ? res.data.children[0].sizeCurrent : 0
          this.lweekCloudView = cloudViewAdd
          this.lweekCloudSize = (cloudSizeAdd / 1024 / 1024 / 1024 / 1024).toFixed(2)
        }
      }).catch(err => console.error(err))

      // 本周推送
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodWeek, period, satelliteGroupId: satelliteGroupId19, type: typePush, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0 && res.data) {
        // if (res.code === 0) {
          const cloudViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          // const cloudSizeAdd = res.data.children.length ? res.data.children[0].sizeCurrent : 0
          this.pushView = cloudViewAdd
          // this.pushSize = (cloudSizeAdd / 1024 / 1024 / 1024 / 1024).toFixed(2)
        }
      }).catch(err => console.error(err))

      // 上周推送
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodWeek, period: periodLast, satelliteGroupId: satelliteGroupId19, type: typePush, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0 && res.data) {
        // if (res.code === 0) {
          const pushViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          this.lweekPushView = pushViewAdd
        }
      }).catch(err => console.error(err))
    },
  },
}
</script>
